import { render, staticRenderFns } from "./DiagnosticProtocolFormDialog.vue?vue&type=template&id=4dd6a1fd"
import script from "./DiagnosticProtocolFormDialog.vue?vue&type=script&lang=js"
export * from "./DiagnosticProtocolFormDialog.vue?vue&type=script&lang=js"
import style0 from "./DiagnosticProtocolFormDialog.vue?vue&type=style&index=0&id=4dd6a1fd&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports